import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg24NotiG = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey400,
      fillRule: "evenodd",
      d: "M14.06 18.283c0 1.33-.896 2.217-2 2.217-1.106 0-2.002-.887-2.002-2.217zM12 4c3.122 0 5.63 2.735 5.63 6.082v3.72l1.602 1.397c.17.149.268.365.268.593v.815c0 .431-.344.78-.768.78H5.268a.774.774 0 0 1-.768-.78v-.815c0-.228.098-.444.268-.593l1.602-1.397v-3.72C6.37 6.735 8.878 4 12 4"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24NotiG$1 = Svg24NotiG;

export { Svg24NotiG$1 as default };
